import { useContext } from "react";
import MenuContext from "../contexts/MenuContext";

function useMenu() {
  const menuContext = useContext(MenuContext);

  if (!menuContext) {
    throw new Error("useMenu must be used within a MenuProvider");
  }

  return menuContext;
}

export default useMenu;
